<div *ngIf="userFound; else noUserFound">
    <div style="display: flex; flex-flow: column nowrap; height: 100%">
        <table mat-table class="table-management" [dataSource]="dataSourceUser" #accountsTable>
            <ng-container matColumnDef="Users">
                <td mat-cell *matHeaderCellDef class="bgWhiteSmoke w-25 p-05-12">
                    <div style="width: 100%; display: flex; justify-content: space-between; padding-bottom: 1.1rem; padding-top: 0.5rem">
                        <div>
                            <h3 translate>ACCOUNT</h3>
                        </div>
                        <div>
                            <button
                                mat-flat-button
                                color="primary"
                                matTooltip="{{ 'M_ACC_NEW' | translate }}"
                                matTooltipClass="tooltip-layout"
                                (click)="onClickShowTabCreationAccount()"
                                class="button-icon-text"
                            >
                                <mat-icon>add</mat-icon>
                                <span translate>ACC_FEAT1</span>
                            </button>
                        </div>
                    </div>

                    <div style="width: 100%; display: flex; justify-content: space-between">
                        <div class="s" style="width: 67%">
                            <div style="display: flex; width: 100%">
                                <mat-icon matPrefix [inline]="true" class="m-r5" style="width: 5%"> search </mat-icon>
                                <input
                                    matInput
                                    [(ngModel)]="searchUser"
                                    (keyup)="onClickApplyFilter($event)"
                                    placeholder="{{ 'M_SEARCH_ACC' | translate }}"
                                />
                            </div>
                            <div>
                                <mat-icon matSuffix [inline]="true" class="pointer" (click)="clearUserSearch()"> close </mat-icon>
                            </div>
                        </div>
                        <div class="s" style="padding: 0 20px">
                            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
                                <div style="width: 100%">
                                    <mat-label translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </mat-label>
                                </div>
                                <div style="display: flex">
                                    <span class="material-icons"> filter_alt </span>
                                    <mat-select (selectionChange)="onClickDoSomething($event)">
                                        <mat-option value="Lista di tutti gli account"
                                            ><span translate>MANAGE_ACCOUNTS.OPT_1</span>
                                        </mat-option>
                                        <mat-option value="Lista dei tuoi account"
                                            ><span translate>MANAGE_ACCOUNTS.OPT_2</span>
                                        </mat-option>
                                        <mat-option value="Lista degli account non modificabili"
                                            ><span translate>MANAGE_ACCOUNTS.OPT_11</span>
                                        </mat-option>
                                        <mat-option value="Account disabilitati" translate
                                            ><span translate>MANAGE_ACCOUNTS.OPT_3</span>
                                        </mat-option>
                                        <mat-option value="Account confermati" translate
                                            ><span translate>MANAGE_ACCOUNTS.OPT_4</span>
                                        </mat-option>
                                        <mat-option value="Account non confermati" translate
                                            ><span translate>MANAGE_ACCOUNTS.OPT_5</span>
                                        </mat-option>
                                        <mat-option value="Account bloccati" translate
                                            ><span translate>MANAGE_ACCOUNTS.OPT_6</span>
                                        </mat-option>
                                        <mat-option value="Devono cambiare la password" translate
                                            ><span translate>MANAGE_ACCOUNTS.OPT_7</span></mat-option
                                        >
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
                <td mat-cell class="w-25 p-05-12" *matCellDef="let row">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                        <div style="display: flex; align-items: center">
                            <div style="position: relative">
                                <div class="circleUserSmall bgGreenDark" style="margin: 0; margin-right: 2rem">
                                    <span> {{ row.AccountName.trim().slice(0, 2).toLocaleUpperCase() }}</span>
                                </div>
                            </div>

                            <div style="display: flex; flex-direction: column">
                                <div style="display: flex">
                                    <div>
                                        <span class="tableRowContent1"> {{ row.AccountName }}</span>
                                    </div>
                                    <div>
                                        <mat-icon
                                            *ngIf="row.Confirmed"
                                            class="tableRowContent1"
                                            matTooltip="{{ 'COMMONS.USER_CONFIRMED' | translate }}"
                                        >
                                            check_circle
                                        </mat-icon>
                                    </div>
                                </div>
                                <span class="tableRowContent2"> {{ row.FullName }}</span>
                            </div>
                        </div>
                        <div>
                            <button
                                *ngIf="row.Confirmed === true && !row.IsCASUser"
                                mat-icon-button
                                matTooltip="{{ 'MANAGE_ACCOUNTS.RESET_PASS_TITLE' | translate }}"
                                matTooltipClass="tooltip-layout"
                                (click)="resetPwd(row.AccountName)"
                            >
                                <mat-icon>vpn_key</mat-icon>
                            </button>

                            <button
                                *ngIf="row.Confirmed === false"
                                mat-icon-button
                                matTooltip="{{ 'MANAGE_ACCOUNTS.SEND_MAIL_TITLE' | translate }}"
                                matTooltipClass="tooltip-layout"
                                (click)="reactivate(row.AccountName)"
                            >
                                <mat-icon>email</mat-icon>
                            </button>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnUser"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnUser"
                class="pointer"
                (click)="onClickShowTabs(row)"
                [ngClass]="row.IsClicked ? 'bgGreenLight2' : ''"
            ></tr>
        </table>
    </div>
    <div>
        <mat-paginator #paginatorUsers [pageSizeOptions]="[3]" [pageSizeOptions]="[5, 10, 25, 100]" style="position: sticky; bottom: 0">
        </mat-paginator>
    </div>
</div>
<ng-template #noUserFound>
    <div>
        <table class="mat-table table-management">
            <tr class="mat-header-row bgWhiteSmoke">
                <th class="w-25 p-05-12">
                    <div style="width: 100%; display: flex; justify-content: space-between; padding-bottom: 1.1rem; padding-top: 0.5rem">
                        <div>
                            <h3 translate>ACCOUNT</h3>
                        </div>
                        <div>
                            <button
                                mat-flat-button
                                color="primary"
                                matTooltip="{{ 'M_ACC_NEW' | translate }}"
                                matTooltipClass="tooltip-layout"
                                (click)="onClickShowTabCreationAccount()"
                                class="button-icon-text"
                            >
                                <mat-icon class="material-icons">add</mat-icon>
                                <span translate>ACC_FEAT1</span>
                            </button>
                        </div>
                    </div>

                    <div style="width: 100%; display: flex; justify-content: space-between">
                        <div class="s" style="width: 67%">
                            <div style="display: flex; width: 100%">
                                <mat-icon matPrefix [inline]="true" class="m-r5" style="width: 5%"> search </mat-icon>
                                <input
                                    matInput
                                    [(ngModel)]="searchUser"
                                    (keyup)="onClickApplyFilter($event)"
                                    placeholder="{{ 'M_SEARCH_ACC' | translate }}"
                                />
                            </div>
                            <div>
                                <mat-icon matSuffix [inline]="true" class="pointer" (click)="clearUserSearch()"> close </mat-icon>
                            </div>
                        </div>
                        <div class="s" style="padding: 0 20px" *ngIf="showFilterOptions">
                            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
                                <div style="width: 100%">
                                    <mat-label translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </mat-label>
                                </div>
                                <div style="display: flex">
                                    <span class="material-icons"> filter_alt </span>
                                    <mat-select (selectionChange)="onClickDoSomething($event)">
                                        <mat-option value="Lista di tutti gli account"
                                            ><span translate>MANAGE_ACCOUNTS.OPT_1</span>
                                        </mat-option>
                                        <mat-option value="Lista dei tuoi account"
                                            ><span translate>MANAGE_ACCOUNTS.OPT_2</span>
                                        </mat-option>
                                        <mat-option value="Lista degli account non modificabili">
                                            <span translate>MANAGE_ACCOUNTS.OPT_11</span>
                                        </mat-option>
                                        <mat-option value="Account disabilitati" translate
                                            ><span translate>MANAGE_ACCOUNTS.OPT_3</span>
                                        </mat-option>
                                        <mat-option value="Account confermati" translate
                                            ><span translate>MANAGE_ACCOUNTS.OPT_4</span>
                                        </mat-option>
                                        <mat-option value="Account non confermati" translate
                                            ><span translate>MANAGE_ACCOUNTS.OPT_5</span>
                                        </mat-option>
                                        <mat-option value="Account bloccati" translate
                                            ><span translate>MANAGE_ACCOUNTS.OPT_6</span>
                                        </mat-option>
                                        <mat-option value="Devono cambiare la password" translate>
                                            <span translate>MANAGE_ACCOUNTS.OPT_7</span>
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </th>
            </tr>
            <tr class="mat-row">
                <td class="mat-cell w-25 p-05-12">
                    <span translate>M_ACC_NOT_FOUND</span>
                </td>
            </tr>
        </table>
        <mat-paginator [hidePageSize]="true"> </mat-paginator>
    </div>
</ng-template>
